
import { motion } from "framer-motion";
import { FaDiscord } from "react-icons/fa";

const DiscordButton = () => {
  const handleClick = () => {
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'discord_join', {
        event_category: 'engagement',
        event_label: 'Discord Join Button Clicked'
      });
    }
  };

  return <motion.a 
    href="https://discord.com/invite/meccRWwMXw" 
    target="_blank" 
    rel="noopener noreferrer" 
    onClick={handleClick}
    whileHover={{
      scale: 1.05
    }} 
    transition={{
      type: "spring",
      stiffness: 400,
      damping: 10
    }} 
    className="w-full h-12 group inline-flex items-center justify-center px-[15px] border-2 border-[#725aff]/10 text-white rounded-md font-bold transition-all transform hover:scale-105 hover:shadow-lg hover:shadow-[#725aff]/20 uppercase tracking-wider bg-[#725aff] hover:bg-[#725aff]/90"
  >
    <FaDiscord className="w-5 h-5 mr-2" />
    <span>Join Discord</span>
    <span className="inline-block transition-transform group-hover:translate-x-1 ml-2">→</span>
  </motion.a>;
};

export default DiscordButton;
